import { useDonateToGitcoin } from "../../DonateToGitcoinContext";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export function TotalAmountInclGitcoinDonation(_ref) {
  let {
    totalDonationAcrossChainsInUSD
  } = _ref;
  const {
    amount
  } = useDonateToGitcoin();
  const totalAmount = totalDonationAcrossChainsInUSD + Number(amount);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs("span", {
      className: "font-inter text-[15px] font-medium text-black",
      children: ["~$", totalAmount.toFixed(2)]
    })
  });
}